import { Maybe } from '@karakuri-web/faq-type'

import { value, values } from './maybe'

export function breadcrumb(url: string, links: { title: string; link: string }[]) {
  const itemListElement = links.map(({ title, link }, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: title,
    item: `${url}${link}`,
  }))
  const breadcrumb = {
    itemListElement,
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
  }
  return breadcrumb
}

export function schemaOrgWebPage(
  siteUrl?: Maybe<string>,
  language?: Maybe<string>,
  defaultDescription?: Maybe<string>,
  defaultTitle?: Maybe<string>,
  buildTime?: string,
  image?: string
) {
  const url = value(siteUrl, '')
  const inLanguage = value(language, '')
  const description = value(defaultDescription, '')
  const name = value(defaultTitle, '')
  return {
    // headline,
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    url,
    inLanguage,
    mainEntityOfPage: url,
    description,
    name,
    // author: {
    //   '@type': 'Person',
    //   name: author
    // },
    // copyrightHolder: {
    //   '@type': 'Person',
    //   name: author
    // },
    copyrightYear: '2019',
    // creator: {
    //   '@type': 'Person',
    //   name: author
    // },
    // publisher: {
    //   '@type': 'Person',
    //   name: author
    // },
    // datePublished: '2019-01-18T10:30:00+01:00',
    dateModified: buildTime,
    image: {
      '@type': 'ImageObject',
      url: image,
    },
  }
}

export function faqPage(
  askMaybe?: Maybe<string>,
  contentsMaybe?: Maybe<
    Maybe<{
      text?: Maybe<string>
      contentFormat?: Maybe<string>
      image?: Maybe<string>
    }>[]
  >
) {
  const ask = value(askMaybe, '')
  const contents = values(contentsMaybe)
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: ask,
        acceptedAnswer: {
          '@type': 'Answer',
          text: contents
            ? contents
                .map(c => c && c.text)
                .filter(c => !!c)
                .join('\n')
            : '',
        },
      },
    ],
  }
}
